module.exports = __webpack_public_path__ + "img/1992-Druckzentrum-Messendorf.36cbe4cf.jpg";